import { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function TemplateQueueRowActions({
  row,
  onView,
  onRemove,
  onRetryFailed,
  onPause,
  onResume,
  onRetryItem,
}) {
  const styles = useTemplateSx();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const status = row?.queue_status;
  const failed = Number(row?.failed) || 0;
  const showRemove = status === 'draft' && Boolean(onRemove);
  const showRetry = failed > 0 && Boolean(onRetryFailed);
  const showPause = ['queued', 'scheduled', 'running'].includes(status) && Boolean(onPause);
  const showResume = status === 'paused' && Boolean(onResume);
  const showRetryItem = status === 'failed' && Boolean(onRetryItem);

  const handleClose = () => setAnchorEl(null);
  const run = (callback) => {
    handleClose();
    callback?.();
  };

  return (
    <Box sx={styles.actionColumnCell} onClick={(event) => event.stopPropagation()}>
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        aria-label="Queue actions"
        sx={styles.rowActionButton}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {onView ? <MenuItem onClick={() => run(onView)}>View destinations</MenuItem> : null}
        {showRetry ? <MenuItem onClick={() => run(onRetryFailed)}>Retry failed</MenuItem> : null}
        {showRetryItem ? <MenuItem onClick={() => run(onRetryItem)}>Retry this number</MenuItem> : null}
        {showPause ? <MenuItem onClick={() => run(onPause)}>Pause</MenuItem> : null}
        {showResume ? <MenuItem onClick={() => run(onResume)}>Resume</MenuItem> : null}
        {showRemove ? (
          <MenuItem onClick={() => run(onRemove)} sx={{ color: 'error.main' }}>
            Remove queue
          </MenuItem>
        ) : null}
      </Menu>
    </Box>
  );
}
